import { render, staticRenderFns } from "./GESPCodeDetail.vue?vue&type=template&id=2b4eace9&scoped=true"
import script from "./GESPCodeDetail.vue?vue&type=script&lang=js"
export * from "./GESPCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./GESPCodeDetail.vue?vue&type=style&index=0&id=2b4eace9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4eace9",
  null
  
)

export default component.exports